import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../Context/GlobalContext";

// const steps = [
//   { id: 1, label: ".", path: "/create-account-1" },
//   { id: 2, label: ".", path: "/create-account-2" },
//   { id: 3, label: ".", path: "/create-account-3" },
//   { id: 4, label: ".", path: "/create-account-4" },
//   { id: 5, label: ".", path: "/reset-password" },
// ];

const SignupProgress = ({ currentStep }) => {
  const { is4Life } = useContext(GlobalContext);

  const getSteps = (is4Life) => {
    const baseSteps = [
      { id: 1, label: ".", path: "/create-account-1" },
      { id: 2, label: ".", path: "/create-account-2" },
    ];

    if (is4Life) {
      baseSteps.push({
        id: 3,
        label: ".",
        path: "/create-account-3",
      });
    }

    baseSteps.push({
      id: is4Life ? 4 : 3,
      label: ".",
      path: "/create-account-5",
    });

    if (!is4Life) {
      baseSteps.push({
        id: is4Life ? null : 4,
        label: ".",
        path: "/reset-password",
      });
    }

    return baseSteps;
  };
  const steps = getSteps(is4Life);
  return (
    <div className="d-flex justify-content-center gap-2 my-4">
      {steps.map((step, index) => {
        const isCompleted = step.id < currentStep;
        const isActive = step.id === currentStep;

        // const handleClick = () => {
        //   if (isCompleted) {
        //     navigate(step.path);
        //   }
        // };

        return (
          <div key={step.id} className="d-flex align-items-center">
            <div
              // onClick={handleClick}
              className={`step-circle ${
                isActive ? "active" : isCompleted ? "completed clickable" : ""
              }`}
              style={{ cursor: isCompleted ? "pointer" : "default" }}
              title={isCompleted ? "Click to go back" : ""}
            >
              {isCompleted ? "✓" : step.id}
            </div>
            {index < steps.length - 1 && <span className="mx-2">→</span>}
          </div>
        );
      })}
    </div>
  );
};

export default SignupProgress;
